import type { SelectProps } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import MuiSelect from '@mui/material/Select'
import { forwardRef, ReactNode } from 'react'
import HintLabel from '../HintLabel'
import InputBase from './InputBase'

type Props =
  | (SelectProps & {
      helperText?: string
      label?: ReactNode
      labelHint?: ReactNode
      placeholder: string
    })
  | (SelectProps & {
      helperText?: string
      label: ReactNode
      labelHint?: ReactNode
      placeholder?: string
    })

const Select = forwardRef((props: Props, _) => {
  const { label, labelHint, children, helperText, ...selectProps } = props

  return (
    <FormControl variant="standard">
      <HintLabel htmlFor={selectProps.id} hint={labelHint}>
        {label}
      </HintLabel>
      <MuiSelect {...selectProps} input={<InputBase />}>
        {children}
      </MuiSelect>
      {helperText && (
        <FormHelperText error={selectProps.error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  )
})

export default Select
